<!-- Компактная метка происхождения строки состава расчёта. -->
<template>
  <span
    v-if="presentation"
    ref="trigger"
    class="plan-breakdown-origin"
    :style="originStyles"
    tabindex="0"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
    @focus="showTooltip"
    @blur="hideTooltip"
  >
    {{ presentation.label }}
  </span>

  <FormulaChipTooltip
    :token="tooltip.visible ? token : null"
    :token-labels="tokenLabels"
    :x="tooltip.x"
    :y="tooltip.y"
  />
</template>

<script>
import FormulaChipTooltip from "@/components/Formula/ChipTooltip.vue";
import { PARAM_TYPE_COLORS } from "@/components/Formula/formulaColors";
import { getBreakdownOriginPresentation } from "@/utils/orderCalculation/breakdownUtils";

export default {
  name: "OrderPlanCalculationBreakdownOrigin",

  components: { FormulaChipTooltip },

  props: {
    origin: { type: String, default: "" },
    token: { type: Object, default: null },
    tokenLabels: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      tooltip: { visible: false, x: 0, y: 0 },
      tooltipTimer: null,
    };
  },

  computed: {
    presentation() {
      return getBreakdownOriginPresentation(this.origin);
    },

    originStyles() {
      if (!this.presentation) return {};

      const colors = PARAM_TYPE_COLORS[this.presentation.colorType];
      return {
        "--plan-breakdown-origin-background": colors.bg,
        "--plan-breakdown-origin-border":
          this.presentation.colorType === "source" ? colors.badge : "transparent",
        "--plan-breakdown-origin-color": colors.text,
      };
    },
  },

  beforeUnmount() {
    clearTimeout(this.tooltipTimer);
  },

  methods: {
    showTooltip() {
      clearTimeout(this.tooltipTimer);
      this.tooltipTimer = setTimeout(() => {
        const rect = this.$refs.trigger?.getBoundingClientRect();
        if (!rect) return;

        this.tooltip = {
          visible: true,
          x: rect.left + rect.width / 2,
          y: rect.top - 8,
        };
      }, 200);
    },

    hideTooltip() {
      clearTimeout(this.tooltipTimer);
      this.tooltip.visible = false;
    },
  },
};
</script>

<style scoped>
.plan-breakdown-origin {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border: 1px solid var(--plan-breakdown-origin-border);
  border-radius: 4px;
  background: var(--plan-breakdown-origin-background);
  color: var(--plan-breakdown-origin-color);
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  white-space: nowrap;
}
</style>
